module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"FILTRO":"FILTRO"},"en":{"FILTRO":"FILTER"},"ca":{"FILTRO":"FILTRE"}}')
  delete Component.options._Ctor
}
